import React from 'react'
import { T, SectionLabel, Sheet, Tabs } from '../nfl/ui'

// "More" tab — the track record (top, same as NFL) + how the model works + a plain-English
// glossary. Same voice as the NFL app's glossary, scoped to what the college model does.

const TERMS = [
  ['Hit %', 'The model’s probability the OVER hits, priced at a realistic per-player line and pulled toward 50% by how much data backs it. Before a book posts a number, this is a model estimate — not a market price.'],
  ['Rating', 'A quick A+ → C letter from the hit % and confidence together. A shiny % on a thin sample can’t earn an A.'],
  ['Confidence', 'DATA QUALITY — games played and how steady the usage is — not how likely the bet is. High % + low confidence = small sample.'],
  ['Projection', 'The model’s expected stat line (yards, catches, TDs) for the game.'],
  ['Def matchup', 'How much the opponent gives up to this position vs the FBS average. Green = a soft spot.'],
  ['Game script', 'How the Vegas spread/total shape volume — trailing teams throw, favorites run.'],
  ['Edge', 'Model fair price vs the posted book price. Positive = the over is beatable at the number (+EV). Shows only once real book lines are in.'],
  ['Value', 'Flags a play where the model beats the posted price past a threshold. It marks a beatable number, not a stake size.'],
  ['Line looks off', 'A posted book line that disagrees with the rest of the market — likely a bad feed row, so we hide the fake edge and warn.'],
]

function GlossaryList() {
  return TERMS.map(([t, d]) => (
    <div key={t} style={{ padding: '10px 2px', borderBottom: `1px solid ${T.border}` }}>
      <div style={{ fontSize: 13, fontWeight: 800, color: T.text, marginBottom: 3 }}>{t}</div>
      <div style={{ fontSize: 12, color: T.muted, lineHeight: 1.5 }}>{d}</div>
    </div>
  ))
}

// Header "?" — the plain-English decoder, one tap from any screen (mirrors the NFL sheet).
export function GlossarySheet({ onClose }) {
  return (
    <Sheet onClose={onClose}>
      <div style={{ padding: '10px 16px 28px' }}>
        <div style={{ fontSize: 17, fontWeight: 900, color: T.text, marginBottom: 3 }}>What the numbers mean</div>
        <div style={{ fontSize: 12, color: T.muted, marginBottom: 6 }}>Every rating and stat on the college board, in plain English.</div>
        <GlossaryList />
      </div>
    </Sheet>
  )
}

function HowItWorks({ status }) {
  const src = status?.data_source === 'espn' ? 'ESPN (free, no quota)' : (status?.data_source || 'ESPN')
  return (
    <div>
      <SectionLabel>How it works</SectionLabel>
      <div style={{ fontSize: 13, color: T.muted, lineHeight: 1.55 }}>
        The same prop engine that powers LINEBRKR’s NFL board, rebuilt for college. Each
        week it pulls the FBS schedule, box scores and Vegas lines, builds season-to-date
        usage and a defense-vs-position table from the game logs themselves, then projects
        pass / rush / receiving yards, receptions and anytime-TD. Injured (OUT) players
        drop off the board automatically; the numbers are calibrated against a walk-forward
        backtest of prior seasons.
      </div>

      <SectionLabel>Glossary</SectionLabel>
      <GlossaryList />

      <SectionLabel>Data</SectionLabel>
      <div style={{ fontSize: 12, color: T.muted, lineHeight: 1.55 }}>
        Source: {src}. Book odds appear when a college-football feed is connected. Nothing
        here is a betting recommendation — it’s research on model projections vs market
        prices. 21+.
      </div>
    </div>
  )
}

const MORE_TABS = ['Record', 'How it works']

export function MoreTab({ status, record, sub, setSub }) {
  const active = MORE_TABS.includes(sub) ? sub : 'Record'
  return (
    <div style={{ paddingBottom: 24 }}>
      <Tabs tabs={MORE_TABS} active={active} onSelect={setSub} />
      {active === 'Record' ? record : <HowItWorks status={status} />}
      <div style={{ height: 16 }} />
    </div>
  )
}
